import Vue from 'vue';
import ClipboardJS from 'clipboard';


// 复制到剪切板
Vue.directive('copy', {
  bind(el, binding, vnode, oldVnode) {
    const _str = binding.value;
    if(_str && ['number', 'string'].includes(typeof _str)) {
        el.setAttribute('data-clipboard-text', binding.value);
        const cb = new ClipboardJS(el, {
          text: binding.value || ''
        });
        cb.on('success', ()=> {
          Vue.prototype.$message.success('复制成功！')
        })
    }else {
      console.warn('请给v-copy绑定字符或数字！');
    }
  },
  update(el, binding) {
    //可能值会动态变化
    el.setAttribute('data-clipboard-text', binding.value);
  }
  
})

// 按钮全局节流设置    v-no-more-click
Vue.directive('noMoreClick', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 500)//设置的是500毫秒
    })
  }
})

// 下拉选择框的分页加载
Vue.directive('loadmore', {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop-1 <= SELECTWRAP_DOM.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
});